module.exports = __webpack_public_path__ + "img/juego2.c97fb52f.png";